import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import GuestCustomerGroupRulesGql from '@/extensions/shop/store/graphql/queries/GuestCustomerGroupRules.gql';
import SaveGuestCustomerGroupRuleGql from '@/extensions/shop/store/graphql/mutations/SaveGuestCustomerGroupRule.gql';
import DeleteGuestCustomerGroupRuleGql from '@/extensions/shop/store/graphql/mutations/DeleteGuestCustomerGroupRule.gql';

export default {
    fetchAll: (variables = {}) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GuestCustomerGroupRulesGql,
                    variables,
                    fetchPolicy: 'no-cache',
                })
                .then(({ data }) => resolve(data.CO_GuestCustomerGroupRules))
                .catch((err) => reject(err));
        }),
    save: (rule) => {
        if (rule === undefined) throw new Error('required argument is missing');
        const payload = _.removeDeepByKey(_.cloneDeep(rule), '__typename');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: SaveGuestCustomerGroupRuleGql,
                    variables: { rule: payload },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_SaveGuestCustomerGroupRule);
                })
                .catch((err) => reject(err));
        });
    },
    delete: (id) => {
        if (id === undefined) throw new Error('required argument is missing');
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DeleteGuestCustomerGroupRuleGql,
                    variables: { id: parseInt(id) },
                })
                .then(async ({ data }) => {
                    await apolloClient.clearStore();
                    resolve(data.CO_DeleteGuestCustomerGroupRule);
                })
                .catch((err) => reject(err));
        });
    },
};
